import { isCirclesUser, isV1Human, isV2Human } from '$services/circles/circles';
import type { Address } from '$types/address';
import { closeModal, openModal } from '$components/bottom-sheet/index.svelte';
import { WalletStatus } from '$types/walletStatus';
import { get4337SafeAddress } from '$services/wallet/migrateSafeWallet';
import { isValidAddress } from '$utils/isValidAddress';
import { getV1ContractAddress, isV1TokenStopped } from '$services/asset/crc/action/mint';
import { goToTransition } from '$utils/goToTransition';
import OwnerIsNotSigner from '$modals/owner-is-not-signer/OwnerIsNotSigner.svelte';
import { showToast } from '$components/toast-manager';
import { loadProfile } from '$services/circlesV2Utils/profile';

let walletAddress: string;

export const login = async (redirectPath: string) => {
  window.localStorage.setItem('metriAddress', walletAddress as string);

  const isV2 = await isV2Human(walletAddress as Address);
  const v1TokenAddress = await getV1ContractAddress(walletAddress as Address);
  const v1Stopped = await isV1TokenStopped(v1TokenAddress);
  if (isV2 && v1Stopped) {
    void goToTransition('right', redirectPath);
  } else {
    void goToTransition('right', '/circles/onboard');
  }
};

export const connectWalletAndStoreData = async (redirectPath: string): Promise<void> => {
  walletAddress = await get4337SafeAddress();

  if (isValidAddress(walletAddress)) {
    //load profile before anything else
    //to prevent race condition in runGuards where stateMe is not set yet
    await loadProfile(walletAddress);

    try {
      if (walletAddress) {
        if (!(await isCirclesUser(walletAddress))) {
          if (await isV1Human(walletAddress)) {
            //if you are a v1 user but not v2 user, go to migrate
            return goToTransition('right', '/migrate');
          } else {
            //if you are not a circles user at all, it means you are a new user waiting for invite
            window.localStorage.setItem('metriAddress', walletAddress);
            return goToTransition('right', redirectPath ?? '/circles');
          }
        } else {
          //If you are a v2 user, normal login (can be a v2 user with a concurrent v1 profile)
          void closeModal();
          return login(redirectPath);
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (event: any) {
      throw new Error(`Wallet creation failed: ${event?.message}`);
    }
  } else if (walletAddress === WalletStatus.RECOVERY_PROGRESS) {
    closeModal();
    showToast('negative', 'Recovery still in progress, check status');
    void goToTransition('right', '/recovery');
  } else if (walletAddress === WalletStatus.LEGACY_WALLET) {
    closeModal();
    void goToTransition('right', '/migrate-safe/legacy-message');
  } else if (walletAddress === WalletStatus.NO_SIGNER) {
    openModal(OwnerIsNotSigner);
  } else if (walletAddress === WalletStatus.NO_WALLET) {
    closeModal();
    showToast('negative', 'No wallet found for this passkey');
  } else {
    //user rejected the passkey prompt or other error
    closeModal();
  }
};
